import * as swcHelpers from '@swc/helpers';
import { actions } from '@grandvisionhq/state';
import { isNewPrescriptionAndUpload } from '../../utils/is-new-prescription-upload.js';
import { startPrescriptionGlassesConfiguration } from '../actions.js';
import { NEW_PRESCRIPTION, RX_SCOPE } from '../constants.js';
import { selectLensTypeSuccess, selectPackageSuccess, resetSelectedPackage, selectAddOnSuccess, resetSelectedAddOn, updatePrescriptionValue, updatePrescriptionRecognitionValues, updatePrescriptionInfo, updatePrescriptionType, updateVerificationAllowed, updateUploadReference, removeUploadReference } from './actions.js';

const getPrescriptionType = (s, frameSku)=>{
    var ref;
    return ((ref = s[frameSku]) === null || ref === void 0 ? void 0 : ref.prescriptionType) || NEW_PRESCRIPTION;
};
var reducer = actions.reducer({}, /**
   * Create a blank configuration but only on the first call
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frameSku , preselectedPrescriptionEntry  }  })=>{
    if (frameSku in s) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: {
            prescriptionType: preselectedPrescriptionEntry || NEW_PRESCRIPTION
        }
    });
}), /**
   * Changes the selected lens type. If no prescriptionPrefill is passed along we reset the prescription data
   */ actions.on(selectLensTypeSuccess, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if ((currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.sku) === payload.lensTypeSku) {
        // Don't do anything if we're reselecting the same SKU
        return s;
    }
    var ref1, _prescriptionPrefill;
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: {
                sku: payload.lensTypeSku,
                prescriptionInfo: swcHelpers.objectSpread({}, (ref1 = currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.prescriptionInfo) !== null && ref1 !== void 0 ? ref1 : {
                    uploadReferences: {}
                }, (_prescriptionPrefill = payload.prescriptionPrefill) !== null && _prescriptionPrefill !== void 0 ? _prescriptionPrefill : {
                    left: {},
                    right: {}
                })
            }
        })
    });
}), /**
   * Changes the selected package for the given frameSku
   */ actions.on(selectPackageSuccess, (s, { payload: { frameSku , packageSku  }  })=>{
    const frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.package) === packageSku) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType(s, frameSku),
            package: packageSku
        })
    });
}), /**
   * This is used for when there's a package selected that isn't compatible with the current lens-type
   */ actions.on(resetSelectedPackage, (s, { payload: { frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType(s, frameSku),
            package: undefined,
            addOn: undefined
        })
    })
), /**
   * Changes the selected add-on for the given frameSku
   */ actions.on(selectAddOnSuccess, (s, { payload: { frameSku , addOnSku  }  })=>{
    const frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.addOn) === addOnSku) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType(s, frameSku),
            addOn: addOnSku
        })
    });
}), /**
   * This is used for when there's a add-on selected that isn't compatible with the current package
   */ actions.on(resetSelectedAddOn, (s, { payload: { frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType(s, frameSku),
            addOn: undefined
        })
    })
), /**
   * Changes the prescription parameters' value for the given frameSku
   */ actions.on(updatePrescriptionValue, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    const currentSide = currentLensType.prescriptionInfo[payload.side];
    if (currentSide[payload.parameter] === payload.value) {
        return s;
    }
    let updatedSide = swcHelpers.objectSpread({}, currentSide, {
        [payload.parameter]: payload.value
    });
    // for undefined parameters, we don't want to add it to the state tree,
    // so we have to filter them out
    if (payload.value === undefined) {
        updatedSide = Object.fromEntries(Object.entries(currentSide).filter(([key])=>key !== payload.parameter
        ));
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    [payload.side]: updatedSide
                })
            })
        })
    });
}), /**
   * set all the prescription values received by prescription recognition
   */ actions.on(updatePrescriptionRecognitionValues, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    left: swcHelpers.objectSpread({}, payload.left),
                    right: swcHelpers.objectSpread({}, payload.right)
                })
            })
        })
    });
}), /**
   * Changes the prescription info for the given frameSku
   */ actions.on(updatePrescriptionInfo, (s, { payload  })=>{
    var ref, ref2;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: ((ref2 = s[payload.frameSku]) === null || ref2 === void 0 ? void 0 : ref2.prescriptionType) || NEW_PRESCRIPTION,
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    additionalInfo: payload.value
                })
            })
        })
    });
}), /**
   * Changes the type of prescription, i.e. existing, email upload, manual input, etc...
   */ actions.on(updatePrescriptionType, (s, { payload  })=>{
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: payload.prescriptionType
        })
    });
}), /**
   * Changes the verification allowed info for the given frameSku
   */ actions.on(updateVerificationAllowed, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    verificationAllowed: payload.value
                })
            })
        })
    });
}), actions.on(updateUploadReference, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    const { left , right  } = currentLensType.prescriptionInfo;
    const rxValues = {
        left,
        right
    };
    const prescriptionType = getPrescriptionType(s, payload.frameSku);
    if (payload.scope === RX_SCOPE && !isNewPrescriptionAndUpload(prescriptionType)) {
        // removing the prev prescription values
        rxValues.left = {};
        rxValues.right = {};
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, rxValues, {
                    uploadReferences: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo.uploadReferences, {
                        [payload.scope]: payload.uploadReference
                    })
                })
            })
        })
    });
}), actions.on(removeUploadReference, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    const { uploadReferences: currentUploadReferences , left , right ,  } = currentLensType.prescriptionInfo;
    const _ref = currentUploadReferences || {}, _scope = payload.scope, remainingScopes = swcHelpers.objectWithoutProperties(_ref, [
        _scope
    ].map(swcHelpers.toPropertyKey));
    const rxValues = {
        left,
        right
    };
    // removing the prescription info when the file is deleted
    if (payload.scope === RX_SCOPE && payload.removeRxValues) {
        rxValues.left = {};
        rxValues.right = {};
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, rxValues, {
                    uploadReferences: remainingScopes
                })
            })
        })
    });
}));

export { reducer };
//# sourceMappingURL=reducer.js.map
